// Surfaces a user-facing error banner inside a Stimulus controller's root
// element when a fetch response is not OK. Intended for player controllers
// whose submissions can land on a deleted (e.g. legacy) route after deploy.
//
// Usage in a player controller's fetch chain:
//
//   .then((r) => {
//     if (handleStaleResponse(this, r)) return null;
//     return r.text();
//   })
//
// Returns true when a banner was rendered (caller should stop processing
// the response).
export function handleStaleResponse(controller, response) {
  if (response.ok) return false;

  // Idempotent — never stack banners on retries.
  if (controller.element.querySelector("[data-stale-submission-error]")) {
    return true;
  }

  const banner = document.createElement("div");
  banner.dataset.staleSubmissionError = "true";
  banner.className =
    "mt-2 px-3 py-2 rounded-ui bg-error-light text-error-dark text-sm";

  const meta = document.querySelector("meta[name='stale-submission-message']");
  banner.textContent =
    meta?.content ||
    "Не удалось отправить ответ. Обновите страницу и попробуйте снова.";

  controller.element.appendChild(banner);
  return true;
}
